@if (hasHiddenResults()) {
  <rt-infobox
    iconName="info-outline"
    [isDismissible]="false"
    type="transparent"
    margin-top-small
    margin-bottom-small
    padding-lr
  >
    {{ 'app.unbiased_hiring.scorecards_hidden' | translate }}
  </rt-infobox>
}
@for (scorecardsResult of scorecardsResults(); track trackByScorecard($index, scorecardsResult)) {
  <rt-interview-result-summary-scorecards-item [scorecardsResult]="scorecardsResult" />
}
